import { render, staticRenderFns } from "./PageCommunity.vue?vue&type=template&id=59a01a63&"
import script from "./PageCommunity.vue?vue&type=script&lang=js&"
export * from "./PageCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports